import PropertySet from '@exp/exp-utils/helper/property';

const _pageProperties = new PropertySet();

export default _pageProperties;
